// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/stylesheets/popover/annotationPopover.styl
// module id = 140
// module chunks = 0